import React, { useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from "@mui/material";

const ConfirmationPopup = ({ open, onClose, onConfirm, message, placeholder }) => {
    const [inputValue, setInputValue] = useState("");

    const handleConfirm = () => {
        onConfirm(inputValue || "Anonymous");
        setInputValue("");
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Confirmation</DialogTitle>
            <DialogContent>
                <p>{message}</p>
                <TextField
                    fullWidth
                    label={placeholder}
                    variant="outlined"
                    value={inputValue}
                    onChange={(e) => setInputValue(e.target.value)}
                    margin="normal"
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="secondary"> Cancel</Button>
                <Button onClick={handleConfirm} color="primary" variant="contained">Confirm</Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmationPopup;